
import Vue from 'vue';
import ColorPicker from '@/components/generic/ColorPicker.vue';
import AppStore from '@/components/AppStore.vue';
import { EventBus } from '@/plugins/eventBus';
import { LogIt } from '@/plugins/webApi';

export default Vue.extend({
  data: () => ({
    start: false,
    logo: '',
    coName: '',
    coCountry: '',
    headerName: '',
    headerColor: 'primary',
    overlay: false,
  }),
  components: {
    ColorPicker,
    AppStore,
  },
  methods: {
    picked(obj: EventListenerOrEventListenerObject): void {
      this.headerName = (obj as any).name;
      this.logo = (obj as any).image;
    },
    done() {
      this.$store.dispatch('THEMED', {
        barColor: this.headerColor,
        logo: this.logo,
        title: this.headerName,
      });
      EventBus.$emit('theme');
    },
    clear() {
      this.coName = '';
      this.logo = '';
      this.headerColor = 'primary';
      this.start = false;
      this.headerName = '';
    },
    chgLogo(p: boolean): void {
      this.overlay = true;
    },
  },
  mounted() {
    LogIt('(Settings/Theme.vue)', false);
    EventBus.$on('searcher', (obj: EventListenerOrEventListenerObject) => {
      this.picked(obj);
    });
    EventBus.$on('colored', (obj: any) => {
      this.headerColor = obj.color;
    });
  },
});
